import { field, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { UNIT_SCHEMA } from '../schema';

export default class Unit extends Model {
    static table = UNIT_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('name') name;

    @relation('business', 'business_id') business;
}